import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import ListServices from "./ListServices";
import PendingAccept from "./PendingAccept";
import styles from './Services.module.css';
import ServicesRegistered from "./ServicesRegistered";
import { useLocation } from "react-router-dom";
const cx = classNames.bind(styles)

const button = [
    {
        code: 'list',
        name: 'Danh sách dịch vụ',
        active: true,
    },
    {
        name: 'Chờ xác nhận',
        active: false,
        code: 'pending'
    },
    {
        name: 'Dịch vụ đã đăng ký',
        active: false,
        code: 'registered'
    }
]

const page = [
    {
        name: 'Danh sách dịch vụ',
        component: <ListServices />,
        code: 'list',
        show: true,
    },
    {
        name: 'Chờ xác nhận',
        component: <PendingAccept />,
        code: 'pending',
        show: false,
    },
    {
        name: 'Dịch vụ đã đăng ký',
        component: <ServicesRegistered />,
        code: 'registered',
        show: false,
    }
]

function Services() {
    const [listButton, setListButton] = useState()
    const [listComponent, setListComponent] = useState()
    // eslint-disable-next-line
    const [dataStore, dispatch] = useStoreContext()
    const location = useLocation()

    useEffect(() => {
        setListButton(button)
        setListComponent(page)
    }, [])

    
    const handleClickButton = (data) => {
        const activeButton = button.map((item) => {
            if (item.code === data) {
                return {
                    ...item,
                    active: true,
                }
            }
            return {
                ...item,
                active: false,
            }
        })
        const activePage = page.map((item) => {
            if (item.code === data) {
                return {
                    ...item,
                    show: true,
                }
            }
            return {
                ...item,
                show: false,
            }
        })
        setListButton(activeButton)
        setListComponent(activePage)
    }
    useEffect(() => {
        if(location && location.state) {
            handleClickButton(location.state.tabActive)
        }
    }, [location])

    useEffect(() => {
        if (dataStore.toggleFocus) {
            handleClickButton(dataStore.toggleFocus)
            dispatch(actions.focusOnRedirect(false))
        }
        // eslint-disable-next-line
    }, [dataStore.toggleFocus])
    return (
        <>
            <div className={cx("header")}>
                <h1 className={cx("title")}>Quản trị dịch vụ</h1>
            </div>
            <div className={cx('container')}>
                <div className={cx('content')}>
                    <div className={cx('content-header')}>
                        <div className={cx("content-title")}>
                            {
                                listButton?.map((item, index) => {
                                    return (
                                        <p key={index} onClick={() => handleClickButton(item.code)} className={cx("button", item.active ? "active" : "")}>{item.name}</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={cx('content-body')}>
                        {listComponent?.map((item, index) => {
                            if (item.show) {
                                return (
                                    <div key={index}>
                                        {item.component}
                                    </div>
                                )
                            }
                            return ''
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Services;